import { ActionWithPayload, AppState, RoleFilter } from "@shared/interfaces";
import { Permission, Role, User } from "@shared/models";
import { actions } from "@shared/store";
import { tokenHandler } from "@shared/utils";
import { AnyAction } from "redux";
import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";

import api from "../api";

function* getRolesSaga({ payload }: ActionWithPayload<RoleFilter>) {
  try {
    const response: { roles: Role[] } = yield call(api.getRoles, payload);
    yield put(actions.getRoles.success(response.roles));
  } catch (error) {
    yield put(actions.getRoles.failure(error as Error));
  }
}

function* getPermissionsSaga() {
  try {
    const response: { permissions: Permission[] } = yield call(api.getPermissions);
    yield put(actions.getPermissions.success(response.permissions));
  } catch (error) {
    yield put(actions.getPermissions.failure(error as Error));
  }
}

function* getUserDetailsSaga() {
  try {
    yield put(actions.startLoading());
    const response: { user: User } = yield call(api.getUserDetails);
    yield tokenHandler.setUser(response.user);
    yield put(actions.getUserDetails.success(response.user));
    yield put(actions.stopLoading());
  } catch (error) {
    yield put(actions.getUserDetails.failure(error as Error));
    yield put(actions.stopLoading());
  }
}

function* watchLoaders(payload: AnyAction) {
  const state: AppState = yield select();
  const { loadingTypes } = state.shared;

  const startedSection = loadingTypes.find(({ startActions }) => startActions.includes(payload.type));
  const stoppedSection = loadingTypes.find(({ stopActions }) => stopActions[payload.type]);

  if (startedSection) {
    yield put(actions.addLoadingSection({ loadingSection: startedSection.name, requestName: payload.type }));
  }
  if (stoppedSection) {
    yield put(
      actions.removeLoadingSection({
        loadingSection: stoppedSection.name,
        requestName: stoppedSection.stopActions[payload.type],
      }),
    );
  }
}

function* sharedSagas() {
  yield takeLatest(actions.getRoles.request, getRolesSaga);
  yield takeLatest(actions.getUserDetails.request, getUserDetailsSaga);
  yield takeLatest(actions.getPermissions.request, getPermissionsSaga);

  yield takeEvery("*", watchLoaders);
}

export default sharedSagas;
